import React from 'react';
import styled from 'styled-components';
import ContainerDimensions from 'react-container-dimensions';
import LocationTable from './LocationTable';

const Page = styled.div`
  height: 100%;
  margin-top: 60px;
`;

const TablePage = () => (
  <Page>
    <ContainerDimensions>
      {({ height }) => <LocationTable key="table" height={height} />}
    </ContainerDimensions>
  </Page>
);

export default TablePage;



// WEBPACK FOOTER //
// ./src/components/TablePage.jsx